// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import "./index.css";

import { PushNotifications } from "@capacitor/push-notifications";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

// 🔹 Automatically unregister old service workers in development
if ("serviceWorker" in navigator && process.env.NODE_ENV === "development") {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister().then(() => {
        console.log("🛑 Old service worker unregistered");
      });
    });
  });
}

// 🔔 Capacitor Push Notifications (Android)
document.addEventListener("deviceready", async () => {
  console.log("📱 Device ready");

  try {
    const permStatus = await PushNotifications.requestPermissions();
    if (permStatus.receive === "granted") {
      await PushNotifications.register();
      console.log("✅ Push notifications registered");
    } else {
      console.log("❌ Push permission denied");
    }
  } catch (err) {
    console.error("❌ Push registration error:", err);
  }

  PushNotifications.addListener("registration", (token) => {
    console.log("📱 ANDROID FCM TOKEN:", token.value);
    // Send token.value to backend if needed
  });

  PushNotifications.addListener("pushNotificationReceived", (notification) => {
    console.log("📩 Foreground push notification:", notification);
  });

  PushNotifications.addListener(
    "pushNotificationActionPerformed",
    (action) => {
      console.log("👉 Notification tapped:", action);
    }
  );
});
